import { render, staticRenderFns } from "./NewOnYourServicesModule.vue?vue&type=template&id=7ebbd2e0&scoped=true"
import script from "./NewOnYourServicesModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewOnYourServicesModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewOnYourServicesModule.vue?vue&type=style&index=0&id=7ebbd2e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebbd2e0",
  null
  
)

export default component.exports